<template>
  <span>
    <span @click="modal = true"><slot></slot></span>
    <v-dialog ref="dialog" v-model="modal" persistent width="290px">
      <v-date-picker v-model="date" scrollable :min="min">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
        <v-btn text color="primary" @click="pick" :disabled="!date">OK</v-btn>
      </v-date-picker>
    </v-dialog></span
  >
</template>

<script>
import moment from "moment";
export default {
  name: "HiDatePicker",
  props: {
    today: {
      type: Boolean,
      default: false
    },
    future: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: null,
      modal: false
    };
  },
  methods: {
    pick() {
      this.modal = false;
      this.$emit("pick", this.date);
    }
  },
  computed: {
    min() {
      if (this.future) {
        const m = moment();
        if (!this.today) m.add(1, "days");
        // console.log(m.format("YYYY-MM-DD"));
        return m.format();
      }
      return null;
    }
  }
};
</script>

<style scoped></style>
